import { create } from 'zustand'
import type { CatalogIntegrationJob } from '@united-square/catalog-contract'

type State = { jobs: CatalogIntegrationJob[]; setJobs: (jobs: CatalogIntegrationJob[]) => void }
export const useCatalogIntegrationStore = create<State>(set => ({
  jobs: [],
  setJobs: jobs => set({ jobs }),
}))
export const CATALOG_REMOTE_CHANGED = 'catalog-remote-changed'
